import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import { IActivityCopyProps, IActivityCopyState } from '../../../models/components/activity-copy';
import * as Actions from '../../../store/actions/activityCopy';
import { Formik } from 'formik';
import { SelectAsync } from '../../input/select/main';
import { IActivityCopyData } from '../../../models/action/activityCopy';
import imgAnn from '../../../static/images/announcement.svg';
import * as CoursePageActions from '../../../store/actions/coursePage';
import Loading from '../../loading/loading';
import ContentLoader from 'react-content-loader';
import { ActivityType } from '../../../models/enums/ActivityType';
import { Confirm } from '../../notification/main';
import ReactGA from 'react-ga4';
import Tooltip from '../../tooltip/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Activity Copy');

class CActivityCopy extends Component<IActivityCopyProps, IActivityCopyState, IActivityCopyData> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    public state: IActivityCopyState = {
        filters: {
            page: 1,
            take: 20,
            total: 0
        },
        row1status: false,
        courseNames: [],
        processes: {
            name: undefined,
            description: undefined,
            isViewing: false,
            reportTemplateGuid: ''
        },
        currentWeek: 0,
        isAll: false,
        disAllowedActivityIds: [],
        selectedActivityIds: [],
        filterInitialValues: {
            activityId: []
        },
        isStarted: false,
        isModalOpen: false,
        targetCourseTermId: ''
    };

    public componentDidMount() {
        this.props.dispatch(
            Actions.GetActivityList('', '', '', false, false, 9999, 0, 'week', 'getActivities', 'get')
        );
    }

    onSubmit = (FormikValues: IActivityCopyProps) => {
        const values: IActivityCopyData[] = JSON.parse(JSON.stringify(FormikValues));
        this.props.dispatch(Actions.GetActivityCopyData('getActivityCopyData', 'set'));
    };

    onSubmitForWeeks = (FormikValues: IActivityCopyProps) => {
        const values: IActivityCopyData[] = JSON.parse(JSON.stringify(FormikValues));
    };

    public onCopy = () => {

        this.reactGaEvent('G_START_COPY_CLICKED');

        Confirm.setConfirm(
            'twoOption',
            () => this.startCopyWithFiles(),
            T.t('r_select_the_copy_method'),
            null,
            null,
            undefined,
            undefined,
            () => this.startCopyWithFileLink(),
            T.t('r_copy_files'),
            T.t('r_get_file_path'),
            () => this.loadingCopy()
        );

        this.setState({ isStarted: true });
    };

    public startCopyWithFiles = async () => {

        this.reactGaEvent('G_startCopyWithFiles_CLICKED');

        var data = '';

        this.props
            .courseActivityList!.filter(item => item.activityType != ActivityType.Assignment && item.activityType != ActivityType.Exam && item.activityType != ActivityType.LTIActivity)
            .map(activity => {
                if (this.state.selectedActivityIds.indexOf(activity!.activityId!) > -1) {
                    const termWeekId = document.getElementsByName('tw_' + activity!.activityId!);
                    if (termWeekId.length > 0) {
                        const twId = termWeekId[0]!.getAttribute('value')!.toString();

                        data += activity.activityType + '_' + activity.activityId + '_' + twId + ',';
                    }
                }
            });

        data = data.substring(0, data.length - 1);

        var targetCourseId = this.getTargetCourseId()

        if (targetCourseId && targetCourseId.length > 0) {
            this.props.dispatch(Actions.getStartActivityCopy(data, targetCourseId, '1', 'getStartActivityCopy', 'set'));
        }
    };

    public loadingCopy = () => {
        var loadingModalDiv = document.createElement('div');
        loadingModalDiv.id = 'copyLoading';
        loadingModalDiv.classList.add('row');
        loadingModalDiv.classList.add('modal');
        loadingModalDiv.classList.add('modal-dialog-centered');
        loadingModalDiv.classList.add('fade');

        var loadingDiv = document.createElement('div');
        loadingDiv.classList.add('spinner_bg');

        loadingModalDiv.setAttribute('role', 'dialog');
        loadingModalDiv.tabIndex = -1;

        loadingModalDiv.setAttribute('aria-labelledby', 'exampleModalLabel');
        loadingModalDiv.style.display = 'block';
        loadingModalDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
        loadingModalDiv.style.padding = '12.5% 35%';
        loadingModalDiv.setAttribute('aria-hidden', 'true');

        loadingModalDiv.appendChild(loadingDiv);

        var donutDiv = document.createElement('div');
        donutDiv.classList.add('donut');

        loadingDiv.appendChild(donutDiv);

        var loadingInnerDiv = document.createElement('span');
        loadingInnerDiv.classList.add('report_title');
        loadingInnerDiv.innerText = T.t('r_copying_activities');

        loadingDiv.appendChild(loadingInnerDiv);

        loadingModalDiv.classList.add('show');

        document.body.appendChild(loadingModalDiv);
    };

    public startCopyWithFileLink = async () => {

        this.reactGaEvent('G_startCopyWithFileLink_CLICKED');

        var data = '';

        this.props
            .courseActivityList!.filter(item => item.activityType != ActivityType.Assignment && item.activityType != ActivityType.Exam && item.activityType != ActivityType.LTIActivity)
            .map(activity => {
                if (this.state.selectedActivityIds.indexOf(activity!.activityId!) > -1) {
                    const termWeekId = document.getElementsByName('tw_' + activity!.activityId!);
                    if (termWeekId.length > 0) {
                        const twId = termWeekId[0]!.getAttribute('value')!.toString();

                        data += activity.activityType + '_' + activity.activityId + '_' + twId + ',';
                    }
                }
            });

        data = data.substring(0, data.length - 1);

        var targetCourseId = this.getTargetCourseId()

        if (targetCourseId && targetCourseId.length > 0) {
            await this.props.dispatch(Actions.getStartActivityCopy(data, targetCourseId, '0', 'getStartActivityCopy', 'set'));
        }
    };

    getActivities() {
        this.props.dispatch(
            Actions.GetActivityList(this.props.courseId, this.props.classId, '', false, false, 9999, 0, 'week', 'getActivities', 'get')
        );
    }

    public sort = (sortKey: string, orderBy: string) => {
        // this.state.filters.orderBy = sortKey + '_' + orderBy;
        this.setState(this.state);
        this.getActivities();
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.courseActivityList && this.props.courseActivityList.length > 0 && this.props.courseActivityList[0].activityId !== '' && event && event.target) {
            this.setState({ isAll: event.target.checked });

            if (!event.target.checked) {
                this.setState({ disAllowedActivityIds: [], selectedActivityIds: [] });
            }
            else {
                this.setState({
                    selectedActivityIds: this.props.courseActivityList.map(x => x.activityId!)
                })
            }
        }
    };

    public findTerm(activityTermWeekId: string) {
        if (this.props.termWeeks && this.props.termWeeks!.length > 0) {
            const termWeek = this.props.termWeeks!.find(x => x.termWeekId === activityTermWeekId);
            if (termWeek) {
                const index = this.props.termWeeks!.indexOf(termWeek);
                return this.props.termWeeks![index].week ? this.props.termWeeks![index].week : '0';
            } else return '0';
        } else return '0';
    }

    onSelectQuestion = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedActivityIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedActivityIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedActivityIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedActivityIds: disAllowedIds });
            }
        }
    };

    public getTargetTermId = () => {
        const data = document.getElementsByName('courseIds');
        if (data.length > 0) {
            const splited = data[0]!
                .getAttribute('value')!
                .toString()
                .split('_');
            return splited[2];
        }
        return '';
    };

    public getTargetCourseId = () => {
        const data = document.getElementsByName('courseIds');
        if (data.length > 0) {
            const splited = data[0]!
                .getAttribute('value')!
                .toString()
                .split('_');
            return splited[1];
        }
        return '';
    };

    public getTargetCourseName = () => { };

    triggerModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    };

    goToSourceCourse = () => {
        const url =
            window.appSettings.DEFAULT_URL + '/u/course?classId=' + this.props.classId + '&activityId=' + this.props.courseId + '&type=1';
        window.open(url, '_self');
    };

    goToTargetCourse = () => {
        const url =
            window.appSettings.DEFAULT_URL + '/u/course?classId=null&activityId=' + this.props.copyResultData!.targetCourseID + '&type=1';
        window.open(url, '_self');
    };

    onclickDiv =() =>
    {
        this.reactGaEvent('G_COPY_ACTIVITY_CLICKED')
        this.setState(prevState => ({...prevState, row1status: !prevState.row1status}));
    }

    reactGaEvent = (actionName: string)=>{

        ReactGA.event({
            category: window.location.host,
            action: actionName,
            label: actionName,
            nonInteraction: true,
          });
    }


    public render() {

        if (
            this.props.copyResultData != null &&
            this.props.copyResultData != undefined &&
            this.props.copyResultData.targetCourseID != '' &&
            this.state.isStarted
        ) {
            var element = document.getElementById('copyLoading');
            if (element != null) {
                element!.classList.remove('show');
                element!.remove();
                this.setState({ isStarted: false });

                this.triggerModal();
            }
        }

        const loadingSpaces = 40;
        //const initialFormValues: IActivityCopyProps = this.props.activityData!;
        const initialFormValues = {
            ...this.props.activityData,
            ...this.props.courseName,
            ...this.props.courseId
        };
        const ProcessesSection = (
            <>

                <Collapse isOpen={this.state.row1status}>
                    <div className="row report-row-expanded">
                        <Formik
                            initialValues={{
                                courseId: this.props.courseId,
                                classId: this.props.classId,
                                copyResultData: this.props.copyResultData
                            }}
                            onSubmit={this.onSubmit}
                        >
                            {formik => {
                                return (
                                    <form className="w-100" role="form">
                                        <>
                                            <div className="container-fluid">
                                                <div className="row mt-0">
                                                    <div className="col-md-6 col-12">
                                                        <h6 className="mt-0">{T.t('r_source_lesson')}</h6>
                                                        <div
                                                            className="custom-alert alert-primary"
                                                            style={{ maxWidth: '100%', color: '#004085 !important' }}
                                                            role="alert"
                                                        >
                                                            <b>{this.props.coursePageclassInformation ? this.props.coursePageclassInformation.courseName ?? "" : ""}</b>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 col-12">
                                                        <h6 className="mt-0">{T.t('r_target_lesson')}</h6>
                                                        <div className="form-input form-group">
                                                            {<SelectAsync
                                                                isMulti={false}
                                                                isSearchable={true}
                                                                initialProcess={false}
                                                                requestType={'post'}
                                                                parameter={{
                                                                    SourceCourseId: formik.values.courseId,
                                                                    IncludedTypes: 'Course',
                                                                    ProgramId: '',
                                                                    IsClassClone: true,
                                                                    SearchedText: '',
                                                                    Skip: 0,
                                                                    Take: 99999,
                                                                    Status: 1
                                                                }}
                                                                placeHolder={T.t('r_activity_type_Course')}
                                                                url={'api/course/teachercourses'}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={true}
                                                                name={'courseIds'}
                                                                value={formik.values.courseId}
                                                                onChange={(e: any) => {
                                                                    formik.handleChange(e);
                                                                    this.getActivities();
                                                                }}
                                                                setFieldValue={formik.setFieldValue}
                                                                errors={formik.errors.courseId}
                                                                touched={formik.touched.courseId}
                                                                isTouched={formik.setFieldTouched}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                isClearable={true}
                                                                setSelectValue={this.props.courseId && formik.values.courseId
                                                                    ? [formik.values.courseId]
                                                                    : []} />}
                                                            <span className="highlight" />
                                                            <span className="bar" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    </form>
                                );
                            }}
                        </Formik>

                        {/* aktivitelerin listelenmesi */}
                        <Loading spinnerId={'getActivities'} height={'calc(100vh - 197px)'}>
                            <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                                <ContentLoader
                                    speed={2}
                                    width={'100%'}
                                    height={360}
                                    viewBox="0 0 1440 160"
                                    backgroundColor="#d9d9d9"
                                    foregroundColor="#ededed"
                                >
                                    <rect x="50" y="6" rx="4" ry="4" width="1440" height="38" />
                                    <rect x="8" y="6" rx="4" ry="4" width="35" height="38" />
                                    <rect x="50" y="55" rx="4" ry="4" width="1440" height="38" />
                                    <rect x="8" y="55" rx="4" ry="4" width="35" height="38" />
                                    <rect x="50" y="104" rx="4" ry="4" width="1440" height="38" />
                                    <rect x="8" y="104" rx="4" ry="4" width="35" height="38" />
                                    <rect x="50" y="153" rx="4" ry="4" width="1440" height="38" />
                                    <rect x="8" y="153" rx="4" ry="4" width="35" height="38" />
                                </ContentLoader>
                            </div>
                        </Loading>

                        {this.props.courseContentWeekActivities && this.props.courseContentWeekActivities !== undefined ? (
                            <div className="col-12 page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                                {this.props.courseActivityList && this.props.courseActivityList.length > 0 ? (
                                    <div>
                                        <ul className="px-3">
                                            <li>
                                                <div className="row  align-items-center">
                                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                                        <div className="tick-radio position-relative">
                                                            <input
                                                                onChange={this.selectAll}
                                                                type="checkbox"
                                                                checked={this.state.isAll}
                                                                name="demo"
                                                                defaultValue="one"
                                                                id="radio-three"
                                                                className="form-radio mr-2"
                                                                style={{zIndex: "unset"}}
                                                                />
                                                        </div>
                                                        <b>{T.t('r_gen_activity_name')}</b>
                                                    </div>
                                                   <div className="col-3">
                                                   {this.props.termWeeks && this.props.termWeeks.length>1 &&
                                                    ( <b>{T.t('r_source_weeks')}</b>)}
                                                    </div>

                                                    <div className="col-3">
                                                        <b>{T.t('r_target_weeks')}</b>
                                                    </div>
                                                </div>
                                            </li>
                                            {this.props.courseActivityList
                                                .filter(
                                                    item => item.activityType != ActivityType.Assignment &&
                                                        item.activityType != ActivityType.Exam && item.activityType != ActivityType.LTIActivity
                                                )
                                                .map(activity => (
                                                    <li style={{ background: 'none' }}>
                                                        <div className="row  align-items-center">
                                                            <div className="col-6 d-flex justify-content-start align-items-center">
                                                                {activity.activityId ? (
                                                                    <div className="tick-radio position-relative mr-2">
                                                                        {activity.alreadyUsed ? (
                                                                            <>
                                                                                <Tooltip data={T.t('r_gen_exam_session_question_already_user')} position='top'>
                                                                                    <i
                                                                                        className="material-icons mr-2"
                                                                                        style={{
                                                                                            width: 20,
                                                                                            height: 20,
                                                                                            fontSize: 20
                                                                                        }}
                                                                                    >
                                                                                        info
                                                                                    </i>
                                                                                </Tooltip>

                                                                                <input
                                                                                    className="form-radio"
                                                                                    style={{ display: 'none' }} />
                                                                            </>
                                                                        ) : (
                                                                            <input
                                                                                data-id={activity.activityId}
                                                                                onChange={this.onSelectQuestion}
                                                                                type="checkbox"
                                                                                name={'chbx_' +
                                                                                    activity.activityId!.toString()}
                                                                                defaultValue="one"
                                                                                id="radio-three"
                                                                                checked={(!this.state.isAll &&
                                                                                    this.state.selectedActivityIds.includes(
                                                                                        activity.activityId!
                                                                                    )) ||
                                                                                    (this.state.isAll &&
                                                                                        !this.state.disAllowedActivityIds.includes(
                                                                                            activity.activityId!
                                                                                        ))}
                                                                                className="form-radio mr-2"
                                                                                style={{zIndex: "unset"}}
                                                                                />
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}

                                                                {activity.activityType ? (
                                                                    <img
                                                                        className="mr-1"
                                                                        style={{ width: '16px' }}
                                                                        src={_common.GetActivityTypeIcons(
                                                                            activity.activityType!
                                                                        )}
                                                                        alt="Link Icon" />
                                                                ) : (
                                                                    ''
                                                                )}
                                                                <span>
                                                                    {activity.name && activity.name.length > 32
                                                                        ? activity.name.slice(0, 32).toString() + ' ...'
                                                                        : activity.name}
                                                                </span>
                                                            </div>


                                                            <div className="col-3" style={{ fontWeight: '500' }}>
                                                                {activity.activityId && this.props.termWeeks && this.props.termWeeks.length>1
                                                                    ? T.t('r_gen_week_count_upper')
                                                                    .replace('{0}', this.findTerm(activity.termWeekId!))
                                                                    : ''}
                                                            </div>
                                                            <div className="col-3">
                                                                <div>
                                                                    {activity.activityType ? (
                                                                        <Formik
                                                                            initialValues={{
                                                                                termWeekId: '',
                                                                                copyResultData: this.props
                                                                                    .copyResultData
                                                                            }}
                                                                            onSubmit={this.onSubmitForWeeks}
                                                                        >
                                                                            {formik2 => {
                                                                                return (
                                                                                    <form className="w-100" role="form">
                                                                                        <>
                                                                                            <div className="form-input form-group">
                                                                                                {<SelectAsync
                                                                                                    isMulti={false}
                                                                                                    initialProcess={false}
                                                                                                    isSearchable={false}
                                                                                                    requestType={'post'}
                                                                                                    parameter={{
                                                                                                        TargetTermIdRef: this.getTargetTermId()
                                                                                                    }}
                                                                                                    placeHolder={T.t(
                                                                                                        'r_time_week'
                                                                                                    )}
                                                                                                    // url={'api/organization/search'}
                                                                                                    url={'api/course/getcoursetermweek'}
                                                                                                    closeMenuOnScroll={false}
                                                                                                    closeMenuOnSelect={true}
                                                                                                    name={'tw_' +
                                                                                                        activity.activityId!.toString()}
                                                                                                    value={formik2
                                                                                                        .values
                                                                                                        .termWeekId}
                                                                                                    onChange={(e: any) => {
                                                                                                        formik2.handleChange(e);
                                                                                                    }}
                                                                                                    setFieldValue={formik2.setFieldValue}
                                                                                                    errors={formik2
                                                                                                        .errors
                                                                                                        .termWeekId}
                                                                                                    touched={formik2
                                                                                                        .touched
                                                                                                        .termWeekId}
                                                                                                    isTouched={formik2.setFieldTouched}
                                                                                                    hasLocalization={true}
                                                                                                    setFieldOnlyValue={true}
                                                                                                    isClearable={false}
                                                                                                    // setSelectValue={
                                                                                                    //     this.props.termWeeks && formik2.values.termWeeks
                                                                                                    //         ? [formik2.values.termWeeks]
                                                                                                    //         : []
                                                                                                    // }
                                                                                                    isDisabled={this.state.selectedActivityIds.findIndex(
                                                                                                        item => item ==
                                                                                                            activity!
                                                                                                                .activityId
                                                                                                    ) > -1 ||
                                                                                                        (this.state
                                                                                                            .isAll &&
                                                                                                            this.state.disAllowedActivityIds.findIndex(
                                                                                                                item => item ==
                                                                                                                    activity!
                                                                                                                        .activityId
                                                                                                            ) < 0)
                                                                                                        ? false
                                                                                                        : true} />}
                                                                                                <span className="highlight" />
                                                                                                <span className="bar" />
                                                                                            </div>
                                                                                        </>
                                                                                    </form>
                                                                                );
                                                                            }}
                                                                        </Formik>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                        <div className="row" style={{ marginTop: '3em' }}>
                                            <a
                                                onClick={this.onCopy}
                                                className={'ml-2 category-tag-square tag-green '.concat(
                                                    this.state.selectedActivityIds.length > 0 || this.state.isAll
                                                        ? ''
                                                        : 'disabledButton'
                                                )}
                                                style={{ position: 'absolute', right: '1em', bottom: '1em' }}
                                            >
                                                {T.t('r_activity_copy_button')}
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                        <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />

                                        <h5
                                            id="searched"
                                            className="d-block"
                                            style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}
                                        >
                                            {T.t('r_no_activity_copy')}
                                        </h5>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center">
                                <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />

                                <h5
                                    id="searched"
                                    className="d-block"
                                    style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}
                                >
                                    {T.t('r_no_activity_copy')}
                                </h5>
                            </div>
                        )}
                    </div>
                </Collapse>
                <Modal
                    id="copy-popup"
                    keyboard={false}
                    isOpen={this.state.isModalOpen}
                    toggle={() => this.triggerModal()}
                    contentClassName={'modal-dialog  copy-modal-dialog'}
                    modalClassName={''}
                >
                    <div className="modal-header border-0 d-flex justify-content-between ">
                        <h6 className="modal-title d-inline-flex"> {T.t('r_activity_copy_summary')} </h6>
                        <button
                            onClick={() => this.triggerModal()}
                            type="button"
                            style={{ border: 'none', background: 'transparent', fontSize: '1.5em' }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-content ">
                        <div className="modal-body p-0">
                            <div className="row d-flex flex-column justify-content-between" style={{ marginTop: 0, marginBottom: '1em' }}>
                                <div className="source_class">
                                    <a onClick={() => this.goToSourceCourse()}>
                                        <span className="material-icons mr-2">output</span>{' '}
                                        {this.props.coursePageclassInformation ? this.props.coursePageclassInformation.courseName ?? "" : ""}
                                    </a>
                                    <Tooltip data={T.t('r_activity_copy_success_count')} position='top'>
                                        <span className='success_copy'>{this.props.copyResultData!.successCount} / {this.props.copyResultData!.cloneActivityCount}</span>
                                    </Tooltip>
                                </div>
                                <div className="from_to">
                                    <span className="material-icons">keyboard_double_arrow_down</span>
                                </div>
                                <div className="target_class">
                                    <a onClick={() => this.goToTargetCourse()}>
                                        <span className="material-icons mr-2">exit_to_app</span>
                                        {this.props.copyResultData!.targetCourseName}
                                    </a>
                                </div>
                            </div>

                            {
                                this.props.copyResultData && this.props.copyResultData.errors != null && this.props.copyResultData.errors != undefined && this.props.copyResultData.errors.length > 0
                                && this.props.copyResultData!.errors.map(txt =>
                                    <div className="row mt-3">
                                        <div className="alert alert-danger d-flex align-items-center" style={{ maxWidth: '100%', borderRadius: '10px' }} role="alert">
                                            <span className="material-icons mr-2">error_outline</span>
                                            {txt}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </Modal>
            </>
        );

        return ProcessesSection;
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityCopyProps): IActivityCopyProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityCopyProps = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        courseActivityList: state.activityCopy.courseActivityList,
        courseNames: state.coursePage.activityCopy,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        termWeeks: state.coursePage.courseContentTermWeeks,
        copyResultData: state.activityCopy.copyResultData,
        courseId: state.coursePage.coursePageActivityId
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.activityCopy.courseActivityList === prev.activityCopy.courseActivityList &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.activityCopy.copyResultData === prev.activityCopy.copyResultData &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const ActivityCopy = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CActivityCopy);

export default ActivityCopy;
